import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";

export const hawoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
} as const;
